/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import TimeSelector from '../../components/timeSelect';

function SelectTimeBox({ id, timeStatus, startTime, endTime, saveTime, open, onToggle }) {
  const convertedStartTime = startTime ? moment(startTime, 'HH:mm:ss').format('h:mm A') : '';
  const convertedEndTime = endTime ? moment(endTime, 'HH:mm:ss').format('h:mm A') : '';
  const [currentStartTime, setCurrentStartTime] = useState(convertedStartTime);
  const [currentEndTime, setCurrentEndTime] = useState(convertedEndTime);

  const handleSave = () => {
    onToggle();
    saveTime({
      timeStatus,
      startTime: moment(currentStartTime, 'h:mm A').format('HH:mm:ss'),
      endTime: moment(currentEndTime, 'h:mm A').format('HH:mm:ss'),
      memberId: id,
    });
  };

  return (
    <div className="relative inline-flex items-center gap-2">
      <p className="text-xs text-ink-700 truncate" style={{ margin: 0, maxWidth: 160 }}>
        {convertedStartTime && convertedEndTime ? `${convertedStartTime} - ${convertedEndTime}` : 'Workspace Default'}
      </p>
      <button
        type="button"
        onClick={onToggle}
        className={`inline-flex items-center box-border px-2.5 py-1 rounded-[6px] text-xs font-medium border bg-white transition flex-shrink-0 ${open ? 'text-[#CC4525] border-[#f3cfc6] hover:bg-[#fdf6f4]' : 'text-ink-900 border-rule hover:border-brand-500 hover:text-brand-700'}`}
        style={{ borderStyle: 'solid' }}
      >
        {open ? 'Cancel' : 'Edit'}
      </button>
      {open && (
        <div
          className="absolute z-10 bg-white rounded-[12px] border border-rule"
          style={{ top: 38, left: 0, width: 380, padding: 16, borderStyle: 'solid', boxShadow: '0 8px 24px rgba(14, 30, 64, 0.12)' }}
        >
          <h5 className="text-sm font-semibold text-ink-900 mb-3">{timeStatus === 'workingHours' ? 'Work Schedule' : 'Work Break Schedule'}</h5>
          <div className="flex gap-3 mb-3">
            <div className="flex-1 min-w-0">
              <span className="block text-xs text-ink-500 mb-1">Starts from</span>
              <TimeSelector time={currentStartTime} setTime={setCurrentStartTime} />
            </div>
            <div className="flex-1 min-w-0">
              <span className="block text-xs text-ink-500 mb-1">Ends at</span>
              <TimeSelector time={currentEndTime} setTime={setCurrentEndTime} />
            </div>
          </div>
          <button
            type="button"
            onClick={handleSave}
            disabled={!(currentStartTime && currentEndTime)}
            className="inline-flex items-center justify-center box-border h-10 w-full px-4 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] disabled:opacity-40 disabled:cursor-not-allowed transition"
          >
            Save
          </button>
        </div>
      )}
    </div>
  );
}

SelectTimeBox.propTypes = {
  id: PropTypes.number.isRequired,
  timeStatus: PropTypes.string.isRequired,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  saveTime: PropTypes.func.isRequired,
  open: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

SelectTimeBox.defaultProps = { startTime: '', endTime: '', open: false };

export default SelectTimeBox;
